import { Component, DoCheck, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiService } from 'app/api.service';

declare var $:any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements DoCheck, AfterViewInit {
  private Parse: any = require('parse');

  currentUser: any;
  model: any = {environment: environment};

  constructor(
    public apiService: ApiService,
    private router: Router
  ) {
    if (this.Parse.User.current()) {
      this.currentUser = this.Parse.User.current();
    }

  }

  ngDoCheck() {
    if (!this.currentUser) {
      if (this.Parse.User.current()) {
        this.currentUser = this.Parse.User.current();
      }
    }
    
  }

  ngAfterViewInit() {
    let html = $('html');
    let body = $('body');
    let noScroll = 'no-scroll';

    let navigationToggle = $('.js-header__navigation-toggle');
    let headerNavigationContainer = $('.header__navigation-container');
    let headerNavigationContainerVisible = 'header__navigation-container--visible';
    let headerNavigationItem = $('.js-header__navigation-item');
    let headerNavigationActiveIndicator = $('.js-header__navigation-item-active-indicator');

    this.model.environment = environment;

    // Open or close the navigation when the toggle button is clicked/tapped
    navigationToggle.on('click', function () {
      if (headerNavigationContainer.hasClass(headerNavigationContainerVisible)) {
        navigationHide();
      } else {
        navigationShow();
      }
    });

    $(function() {
      // Scale and position the active indicator on page load if there is an active navigation item
      showHideActiveIndicator();

      body.on('click', function() {
        showHideActiveIndicator();
      });

      // Close the navigation menu when the logo or a navigation item is clicked
      $('.js-header__logo-link').add('.js-header__navigation-item').add('.header__sub-navigation-item').on('click', function() {
        navigationHide();
      });

      // Scale and position the active indicator on hover
      headerNavigationItem.hover(function() {
        positionAndScaleActiveIndicator($(this));

        setTimeout(function() {
          headerNavigationActiveIndicator.addClass('header__navigation-item-active-indicator--is-visible');
        }, 300);
      }, function() {
        if (headerNavigationItem.hasClass('header__navigation--is-active')) {
          positionAndScaleActiveIndicator($('.js-header__navigation-item.header__navigation--is-active'));
          headerNavigationActiveIndicator.addClass('header__navigation-item-active-indicator--is-visible');
        } else {
          setTimeout(function() {
            headerNavigationActiveIndicator.removeClass('header__navigation-item-active-indicator--is-visible');
          }, 300);
        };
      });
    });

    // Handle re-positioning the active indicator on window resize as well
    $(window).on('resize', function() {
      if (headerNavigationItem.hasClass('header__navigation--is-active')) {
        positionAndScaleActiveIndicator($('.header__navigation--is-active'));
      }

      // Set button widths if required
      roundTransparentButtonWidths();
    });

    // Show navigation
    function navigationShow() {
      let bodyWidth = body.width();
      let scrollPos = $(window).scrollTop();

      html.addClass(noScroll);
      body.addClass(noScroll).css({'top': -scrollPos, 'width': bodyWidth}).attr('data-scroll-position', scrollPos);
      headerNavigationContainer.addClass(headerNavigationContainerVisible);
      $('.header__navigation-toggle-inner').addClass('header__navigation-toggle-inner--active');
    }

    // Hide navigation
    function navigationHide() {
      html.removeClass(noScroll);
      body.removeClass(noScroll).removeAttr('style');
      headerNavigationContainer.removeClass(headerNavigationContainerVisible);
      $('.header__navigation-toggle-inner').removeClass('header__navigation-toggle-inner--active');
      $(window).scrollTop(body.data('scroll-position'));
    }

    // Desktop hover indicator
    function positionAndScaleActiveIndicator(element) {
      let headerNavigationItemWidth = $(element).outerWidth();
      let headerNavigationItemOffset = $(element).offset();

      headerNavigationActiveIndicator.css({left: headerNavigationItemOffset.left, width: headerNavigationItemWidth});
    }

    // Show or hide the active indicator dependent on the presence of an active navigation link
    function showHideActiveIndicator() {
      if (headerNavigationItem.hasClass('header__navigation--is-active')) {
        positionAndScaleActiveIndicator($('.header__navigation--is-active'));
        headerNavigationActiveIndicator.addClass('header__navigation-item-active-indicator--is-visible');
      } else {
        headerNavigationActiveIndicator.removeClass('header__navigation-item-active-indicator--is-visible');
      }
    }

    // Round button widths up to the nearest full pixel to prevent sub-pixel rendering issues
    function roundTransparentButtonWidths() {
      if ($(window).width() >= 1024) {
        setTimeout(function() {
          $('.button--transparent, .button--dark-background, .button--red-background').not('.button--full-width, .button--set-width').each(function() {
            var width = $(this).width();
            var roundedWidth = Math.ceil(width);

            // If the rounded width does not equal the starting width, then apply the rounded width to the button element
            if (roundedWidth != width) {
              $(this).width(roundedWidth).data('original-width', width);
            }
          });
        }, 100);
      } else {
        $('.button--transparent, .button--dark-background, .button--red-background').not('.button--full-width, .button--set-width').width('auto');
      }
    }
  }

  logOut() {
    this.apiService.Parse.User.logOut().then(() => {
      this.currentUser = null;
      this.router.navigate(['/']);
    });
  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/header/header.component.ts